import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig } from '../../models/https';
import {
    IPaymentDetailsData,
    IPaymentDetailsResponse,
} from '../../models/trackPage/paymentDetails.model';
import useHttps from '../useHttps';

const useGetPaymentDetails = () => {
    const request = useHttps();

    const [paymentDetails, setPaymentDetails] =
        useState<IPaymentDetailsData | null>(null);
    const [paymentDetailsLoading, setPaymentDetailsLoading] = useState(false);

    const onPaymentDetailsError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ??
            'Error occurred while fetching payment details'
        );
    };

    const onPaymentDetailsSuccess = (response: IPaymentDetailsResponse) => {
        setPaymentDetails(response?.data ?? null);
    };

    const getPaymentDetails = (packageId: string) => {
        const url: HttpConfig = {
            url: `general-service/external/packages/payment/summary/${packageId}`,
            method: 'get',
        };

        request(
            url,
            onPaymentDetailsSuccess,
            setPaymentDetailsLoading,
            onPaymentDetailsError
        );
    };

    return { getPaymentDetails, paymentDetailsLoading, paymentDetails };
};

export default useGetPaymentDetails;
